var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Documents"}},[_c('List'),_c('ViewDocument')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }